import React, { useContext, useEffect, useState } from 'react'

import FilterAccommodationType from 'client/components/FilterAccommodationTypes'
import FilterCategory from 'client/components/FilterCategory'
import FilterFacilities from 'client/components/FilterFacilities'
import FilterPrices from 'client/components/FilterPrices'
import FilterRatings from 'client/components/FilterRatings'
import { type FormValues } from '@s4l/ds'
import { FiltersContext } from '../FiltersContainer/context'
import FilterThemes from 'client/components/FilterThemes'
import { SearchFilters } from '@s4l/uikit'
import { SearchFilters as SearchFiltersModel } from '@s4l/stayforlong/property/SearchFilters'
import { useSelector } from 'react-redux'
import { getDistributionPriceRange, getIsFetching } from 'src/effects/Properties/selectors'
import { ListOfPriceDistribution } from '@s4l/stayforlong/property/ListOfPriceDistribution'
import { useNewFilters } from 'src/hooks/useNewFilters'
import { useKafkaEvent } from 'src/hooks/useKafkaEvent'
import { PAGES, SECTIONS } from 'src/hooks/useKafkaEvent/constants'

interface IFiltersProps {
  onSubmit?: (filters: FormValues) => void
}

const Filters = ({ onSubmit }: IFiltersProps) => {
  const distributionPriceRange = useSelector(getDistributionPriceRange)
  const isFetching = useSelector(getIsFetching)

  const { hasNewFilters, hasExtendedFilters } = useNewFilters()

  const { filters, setFilters } = useContext(FiltersContext)
  const [isLoadingPriceDistribution, setIsLoadingPriceDistribution] = useState(true)

  const { sendEvent: sendFiltersBottomSheetClosed } = useKafkaEvent({
    page: PAGES.LIST,
    eventName: 'filters_bottom_sheet_closed',
  })

  const onBottomSheetClosed = () => {
    sendFiltersBottomSheetClosed({ section: SECTIONS.SEARCH_FILTERS })
  }

  function handleApplyFilters(newFilters: FormValues) {
    setFilters(prev => ({ ...prev, ...newFilters }))
  }

  function onSubmitInternal(newFilters: FormValues) {
    handleApplyFilters(newFilters)
    onSubmit?.(newFilters)
  }

  const filtersModel = SearchFiltersModel.fromPrimitives(filters)

  const listOfPriceDistributionModel =
    ListOfPriceDistribution.fromLegacyContext(distributionPriceRange)

  useEffect(() => {
    if (!isLoadingPriceDistribution) return

    setIsLoadingPriceDistribution(isFetching)
  }, [isFetching, isLoadingPriceDistribution])

  if (hasNewFilters) {
    return (
      <SearchFilters
        isLoadingPriceDistribution={isLoadingPriceDistribution}
        onFilterChange={handleApplyFilters}
        onSubmit={onSubmitInternal}
        defaultFiltersJSON={filtersModel.toJSON()}
        listOfPriceDistributionJSON={listOfPriceDistributionModel.toJSON()}
        showExtendedFilters={hasExtendedFilters}
        onBottomSheetClosed={onBottomSheetClosed}
      />
    )
  }

  return (
    <>
      <FilterPrices />
      <FilterCategory />
      <FilterRatings />
      <FilterThemes />
      <FilterAccommodationType />
      <FilterFacilities />
    </>
  )
}

export default Filters
